import React, { useState } from 'react'
import axios from "axios";
import { Auth } from "aws-amplify";
import { AlertTitle, Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Divider, IconButton, List, ListItem, ListItemText, Snackbar } from '@mui/material'
import MuiAlert from '@mui/material/Alert';
import { useTranslation, Trans } from "react-i18next";

import CloseIcon from '@mui/icons-material/Close';
import ArchiveIcon from '@mui/icons-material/Archive';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="standard" {...props} />;
});

const TransferStudent = ( {handleClose, studentData, status} ) => {
  // console.log(studentData)
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState([]);
  const [transferState, setTransferState] = useState(false)

  const { t } = useTranslation()

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return
    setToastOpen(false);
  };

  const transferStudent = async (studentData, status) => {

    Auth.currentSession()
    .then(async (data) => {
      const jwtToken = data.idToken.jwtToken;
      const adminId = data.idToken.payload["custom:db_id"]

      try {
        const transferResponse =  await axios.post("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/dropbox-export", 
          JSON.stringify({
            "studId": studentData.studId,
            "status": status
          }), 
          {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
          }
        });
        // console.log("Transfer Response: ",transferResponse.data)
        if(transferResponse.data.status === "success") {
          alert(t("admin.students.transferStudentDialogue.info_transferSuccess"));
          setToastType(["success", "Dropbox Transfer Successful!"])
          window.location.reload()
        }
        else{
          alert("Transfer Cancelled: \n"+transferResponse.data.message)
          setToastType(["error", transferResponse.data.message])
        }
        setToastOpen(true)
        setTransferState(false)
      }
      catch (error) {
        if ([406].includes(error.response.status)) setToastType(["error", error.response.data.message])
        else{
          console.log(error)
          setToastType(["error", t("commonItems.error_api_generic")])
        }
        setToastOpen(true)
        setTransferState(false)
      }
    })
    .catch((err) => console.log(err));
  };

  const handleTransfer = (status) => {
    if(!studentData.test){
      alert(t("commonItems.error_testNotStarted"))
      return
    }

    setTransferState(true)
    transferStudent(studentData, status)
  }

  return (
    <>
      <Snackbar open={toastOpen} autoHideDuration={5000} onClose={handleToastClose}>
        <Alert onClose={handleToastClose} severity={toastType[0]} sx={{ width: '100%' }}>
        {toastType[1]}
        </Alert>
      </Snackbar>
      <DialogTitle sx={{display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap"}}>
        <ArchiveIcon color="info" sx={{fontSize: "1.25rem"}}/>
        <b>{status ? t("admin.students.transferStudentDialogue.title_longAbsentee") : t("admin.students.transferStudentDialogue.title_leftSchool") }</b>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <div className='transferStudent' style={{display: "flex", flexDirection: "column", gap: "1rem"}}>
          {(studentData.test ? studentData.test.status === 1 : false)
          ? 
            <>
              <MuiAlert severity="info" className="uploadInstructions">
                <AlertTitle><b>{t("admin.students.transferStudentDialogue.instructions_title")}</b></AlertTitle>
                  <Divider/>
                  <List dense={true} sx={{listStyleType: "decimal", listStylePosition: "inside"}}>
                    {status ?
                      <ListItem disableGutters>
                        <ListItemText primary={<p>
                            <Trans 
                              i18nKey={"admin.students.transferStudentDialogue.instructions_line1_longAbsentee"}
                              components={{
                                1: <strong></strong>
                              }}
                            />
                          </p>}
                        />
                      </ListItem>
                    :
                      <ListItem disableGutters>
                        <ListItemText primary={<p>
                            <Trans 
                              i18nKey={"admin.students.transferStudentDialogue.instructions_line1_leftSchool"}
                              components={{
                                1: <strong></strong>
                              }}
                            />
                          </p>}
                        />
                      </ListItem>
                    }
                    <ListItem disableGutters>
                      <ListItemText primary={<p>
                          <Trans 
                            i18nKey={"admin.students.transferStudentDialogue.instructions_line2"}
                            components={{
                              1: <strong></strong>
                            }}
                          />
                        </p>}
                      />
                    </ListItem>
                  </List>
              </MuiAlert>
              <div className="transferStudentDetails" style={{display: "flex", gap:"1rem", backgroundColor: "#F1F3F9", borderRadius: "10px", padding: "1rem"}}>
                <div style={{display: "flex", flexDirection: "column", flex: "0.7", gap: "0.5rem"}}>
                  <h4>{t("commonItems.textLabel_studentBasicDetails")}:</h4>
                  <p>{t("commonItems.textLabel_studentName")}: {studentData.studentName}</p>
                  <p>{t("commonItems.textLabel_gender")}: {studentData.gender}</p>
                  <p>{t("commonItems.textLabel_orgStudId")}: {studentData.orgStudId}</p>
                </div>
                <Divider orientation="vertical" flexItem/>
                <div style={{display: "flex", flexDirection: "column", gap: "0.5rem"}}>
                  <h4>{t("commonItems.textLabel_classDetails")}:</h4>
                  <p>{t("commonItems.textLabel_class")}: {studentData.std}</p>
                  <p>{t("commonItems.textLabel_section")}: {studentData.divn}</p>
                  <p>{t("commonItems.textLabel_rollNo")}: {studentData.rollNo}</p>
                </div>
              </div>
            </>
          :
            <MuiAlert severity="error">
              <AlertTitle><b>{t("admin.dropbox.info_droboxNotAvailable")}</b></AlertTitle>
            </MuiAlert>
          }
        </div>
      </DialogContent>
      <DialogActions>
        {(studentData.test ? studentData.test.status === 1 : false) 
        ? 
        <>
            <h4 style={{marginRight: "auto", paddingLeft: "1rem", fontSize: "14px"}}>
              {status ?
                t("admin.students.transferStudentDialogue.footer_longAbsentee")
              : 
                t("admin.students.transferStudentDialogue.footer_leftSchool")
              }
            </h4>
            <Button color="info" variant="contained" onClick={handleClose}>{t("admin.students.transferStudentDialogue.buttonLabel_cancel")}</Button>
            <Button color="warning" variant="contained" disabled={transferState} onClick={() => handleTransfer(status)}>
              {status ? t("admin.students.transferStudentDialogue.buttonLabel_longAbsentee") : t("admin.students.transferStudentDialogue.buttonLabel_leftSchool")}
              {transferState ? <CircularProgress size="1rem" color="info" sx={{marginLeft: "0.25rem"}}/> : ""}
            </Button>
          </>
        :
          <Button color="info" variant="contained" onClick={handleClose}>{t("commonItems.buttonLabel_close")}</Button>
        }
      </DialogActions>
    </>
  )
}

export default TransferStudent